import { Agencies, type AgenciesProps } from '@/components/Custom'

interface CustomBlockProps extends AgenciesProps {
  type: 'AGENCIES' | 'ECRED_LOAN_SIMULATOR'
}

const CustomBlock = ({ type, ...props }: CustomBlockProps) =>
  type === 'AGENCIES' ? <Agencies {...props} /> : null

export default CustomBlock
